import type { ComponentProps } from 'react';

const EmptyStateInvoices = (props: ComponentProps<'svg'>) => (
  <svg
    aria-label="Empty state for invoices"
    xmlns="http://www.w3.org/2000/svg"
    width={62}
    height={52}
    fill="none"
    {...props}
  >
    <path
      fill="#4F9493"
      d="m.68 17.413 45.813-5.556 4.423 34.891-41.804 5.07L.68 17.412Z"
    />
    <path
      fill="#85CFC9"
      d="m9.111 51.816 6.336-32.22 20.214-1.83-1.175 6.375 26.55-3.478-10.12 26.084-41.805 5.07Z"
    />
    <path
      fill="#355D60"
      d="M38.793 2.297 36.422 3.45l2.495 5.003 2.37-1.155-2.494-5.002ZM46.377.946l-1.895 6.316 2.535.742 1.895-6.316-2.535-.742ZM54.8 6.72l-5.512 2.9 1.245 2.31 5.512-2.901L54.8 6.72Z"
    />
    <path
      fill="#5BB0AA"
      d="M43.721 34.029 22.28 36.532l.203 1.696 21.442-2.504-.203-1.695ZM33.532 31.091l-10.592 1.25.204 1.695 10.593-1.25-.205-1.695ZM42.997 38.18l-21.442 2.503.202 1.695L43.2 39.875l-.202-1.695Z"
    />
  </svg>
);

export default EmptyStateInvoices;
